import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const Container2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display:block;
    // margin-left: 19px;
    width:100%;
    `}
`;

export const BodyTextContainer = styled(Grid)`
    padding-top: 10px;
    padding-left: 0px;
    font-family: 'AvenirNextWorld Regular';
    font-size: 15px;
    color: #202124;
    text-align: left;
    ${media.mediumDevice`
    padding-left: 4px;
`}
    ${media.mobileDevice`
    margin-left: 0;
    padding-left: 20px;
    
    `}
`;

export const DistrictGrid = styled(Grid)`
    ${media.mobileDevice`
   display: none;
    `}
`;

export const DistrictHeading = styled(Grid)`
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
`;

export const DistrictName = styled(Grid)`
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
`;

export const TerritoryGrid = styled(Grid)`
    ${media.mobileDevice`
   display: none;
    `}
`;

export const TerritoryGridMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    // margin-left: 5% !important;
    margin-top: 20px !important;
    `}
`;

export const DistrictGridMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    // margin-left: 5% !important;
    margin-top: 20px !important;
    `}
`;

export const TerritoryHeading = styled(Grid)`
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
`;

export const TerritoryName = styled(Grid)`
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    width: ${({isMobile}) => isMobile ? 'max-content' : '200px'};
    overflow-wrap: ${({isMobile}) => isMobile ? 'normal' : 'break-word'};
`;

export const BodyGridContainer = styled(Grid)`
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #ececec;
    border-radius: 6px 6px 6px 6px;
    padding: 15px 0;
    margin-top: 10px;
    ${media.mediumDevice`
        // margin-bottom: 150px;
    `}
    ${media.mobileDevice`
    width: 94% !important;
    // margin-left: 10px;
    margin: 10px auto;
    padding: 15px;
    `}
`;

export const Name = styled(Grid)`
    padding-left: 19px;
    ${media.mobileDevice`
    padding-left: 0;
    `}
`;

export const User1 = styled(Grid)`
    color: #140f4b;
    font-size: 16px;
    font-family: 'AvenirNextWorld Demi';
`;

export const Designation1 = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
`;

export const Designation3 = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
    display: none;
    `}
`;

export const Designation2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: #3C3C3C;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    margin: 2px 0 0 10px;
    `}
`;

export const ValidDate = styled(Grid)`
    color: #3c3c3c;
    font-size: 15px;
    padding-left: 6px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
   display: none;
    `}
`;

export const Line = styled(Grid)`
    margin: 17px 0px 17px 35px;
    width: 693px;
    background-color: #707070;
    border: 0.6px solid #707070;
    opacity: 0.3;
    ${media.mobileDevice`
    width: 100%;
    margin: 20px auto;
    `}
`;

export const Date = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
    margin: 2px 0 0 5px;
    `}
`;

export const LineMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: #202124;
    opacity: 0.7;
    padding-left: 5px;
    `}
`;
export const UserName = styled(Grid)`
    color: #3c3c3c;
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
`;

export const Created = styled(Grid)`
    ${media.mobileDevice`
    display: flex;
    // margin-left: 18px !important;
    `}
`;

export const CreatedByMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    width: 100%;
    margin-top: 10px;
    // margin-left: 18px;
    display: block;
    font-family: 'AvenirNextWorld Demi'; 
    font-size: 14px;
    color: #202124;
    `}
`;

export const ValidDateMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
display: block;
font-family: 'AvenirNextWorld Regular'; 
font-size: 16px;
color: #202124;
    `}
`;

export const ValidDateHeadingMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
margin-top: 10px;
display: block;
font-family: 'AvenirNextWorld Demi'; 
font-size: 14px;
color: #202124;
    `}
`;

export const HeaderTextContainer = styled(Grid)`
    color: #3c3c3c;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    display: none !important;
    `}
`;

export const HeaderGridContainer = styled(Grid)`
    background: #ffffff;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #ececec;
    border-radius: 6px 6px 0px 0px;
    // height: 46px;
    padding: 10px;
    position: sticky;
    top: 0px;
    z-index: 1;
    ${media.mobileDevice`
    display: none !important;
    `}
`;
